import { Bot, X } from "lucide-react";

export const ChatbotHeader = ({ onClose }) => (
  <div className="flex items-center justify-between p-4 bg-gradient-to-r from-red-600 to-red-700 text-white">
    <div className="flex items-center gap-2">
      <div className="w-9 h-9 rounded-full bg-white/20 flex items-center justify-center">
        <Bot className="h-5 w-5" />
      </div>
      <div>
        <div className="font-semibold text-sm">Assistant Mediastore</div>
        <div className="text-xs text-red-100">Réponses instantanées · IA</div>
      </div>
    </div>
    <button
      type="button"
      onClick={onClose}
      aria-label="Fermer le chatbot"
      data-testid="chatbot-close-btn"
      className="p-1 rounded hover:bg-white/20"
    >
      <X className="h-5 w-5" />
    </button>
  </div>
);
